'use client'

import React from 'react'

import {useCodeFormSubmit} from '@/src/features/auth/model/use-code-form-submit'
import {CodeForm} from '@/src/features/auth/ui/code-form'

type CodeFormContainerProps = {
  interval: number
  isPending: boolean
  onConfirm: (params: {code: string; phone: string; token: string}, callbacks?: {onError?: (error: Error) => void}) => void
  phone: string
  onBack: () => void
}

export const CodeFormContainer = ({isPending, onConfirm, onBack, interval, phone}: CodeFormContainerProps) => {
  const {onSubmit, remaining, isTokenReady, captchaProps} = useCodeFormSubmit({onConfirm, phone, interval})

  return (
    <CodeForm
      isPending={isPending}
      isTokenReady={isTokenReady}
      remaining={remaining}
      onSubmit={onSubmit}
      onBack={onBack}
      captchaProps={captchaProps}
    />
  )
}
